import React, {useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import Footer from "./Footer";
import TaglineMarquee from "./TaglineMarquee";
const MainLayout = (props) => {
    return (
        <div className="mainlayout-maindiv">

             {/* 🔹 Top me Tagline */}
  <TaglineMarquee />
            <Header />
            <div className="mainlayout-body">
                {props.children}
            </div>
            <Footer />
        </div>
    )
}

export default MainLayout